import { StyledMobileListCard } from './style';

export interface MobileListField {
  name: string;
  label?: string;
  render?: (value: any, record: any) => React.ReactNode;
  itemClassName?: string;
}

export interface MobileListCardProps {
  coverFields?: MobileListField[];
  bodyFields: MobileListField[];
  record: any;
  footerFields?: MobileListField[];
  bodyTripleSectionFields?: MobileListField[];
  onClick?: () => void;
  className?: string;
}

export const MobileListCard = ({
  coverFields,
  bodyFields,
  record,
  footerFields,
  bodyTripleSectionFields,
  onClick,
  className,
}: MobileListCardProps) => {
  const cover = coverFields && (
    <div className={'mobile-list-card-cover'}>
      {coverFields.map((field, index) => (
        <div key={index} className={'mobile-list-card-cover-item'}>
          {field.render
            ? field.render(record[field.name], record)
            : record[field.name]}
        </div>
      ))}
    </div>
  );

  const body =
    bodyFields && bodyFields.length > 0 ? (
      <div className={'mobile-list-card-body-wrapper'}>
        {bodyFields.map((field, index) => {
          const renderedValue = field.render
            ? field.render(record[field.name], record)
            : record[field.name];
          if (renderedValue === null) return null;
          return (
            <div key={index} className={'mobile-list-card-body-item'}>
              {field.label && <span>{field.label}</span>}
              <span className={field.itemClassName}>{renderedValue}</span>
            </div>
          );
        })}
      </div>
    ) : undefined;

  const bodyTripleSection =
    bodyTripleSectionFields && bodyTripleSectionFields.length > 0 ? (
      <div className={'mobile-list-card-body-triple-section-wrapper'}>
        {bodyTripleSectionFields.map((field, index) => (
          <div
            key={index}
            className={'mobile-list-card-body-triple-section-item'}
          >
            {field.label && <span>{field.label}</span>}
            <span className={field.itemClassName}>
              {field.render
                ? field.render(record[field.name], record)
                : record[field.name]}
            </span>
          </div>
        ))}
      </div>
    ) : undefined;

  const hasBodyContent =
    bodyFields &&
    bodyFields.length > 0 &&
    bodyFields.some((field) => {
      const renderedValue = field.render
        ? field.render(record[field.name], record)
        : record[field.name];
      return (
        renderedValue !== null &&
        renderedValue !== undefined &&
        renderedValue !== ''
      );
    });

  const isSeparated = !!cover && !!hasBodyContent;

  const footerSection =
    footerFields && footerFields.length > 0 ? (
      <div className={'mobile-list-card-footer'}>
        {footerFields.map((field, index) => (
          <div className={'mobile-list-card-footer-item'} key={index}>
            {field.render
              ? field.render(record[field.name], record)
              : record[field.name]}
          </div>
        ))}
      </div>
    ) : null;

  return (
    <StyledMobileListCard
      cover={cover}
      className={`styled-mobile-list-card ${!isSeparated ? 'separated' : ''}${onClick ? ' is-clickable' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
    >
      <div className={'mobile-card-content-wrapper'}>
        {body}
        {bodyTripleSection}
        {footerSection}
      </div>
    </StyledMobileListCard>
  );
};
